var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagazine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.049s-3.341-2.34-7.293-2.92C3.182 3.905 2 5.223 2 6.764v9.924c0 1.236 1.115 2.165 2.351 2.157 3.492-.022 6.037 1.22 7.1 1.849.342.202.772.23 1.13.059 1.373-.655 4.992-2.135 8.919-1.704M12 12v8.5M12 7.049s3.341-2.34 7.293-2.92C20.817 3.905 22 5.223 22 6.764v8.285",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazine);
export default __webpack_public_path__ + "static/media/magazine.75388b9b31a90f53a51da775dd5b7d0a.svg";
export { ForwardRef as ReactComponent };